import $ from "jquery";
import vuwer from "@pressmedia/vuwer";

export default {
	_addEventListenerForPeriodConfig() {
		if(!this.$self) {
			return this;
		}
		
		const $config = this.$self.find(".period-config");
		if(!$config.length) {
			return this;
		}
		
		$config
		.on("click", ".btn-toggle", (e, isTrigger) => {
			const $btn = $(e.currentTarget);
			let $confWndw = $btn.data("target");
			
			if(!$confWndw || !$confWndw.length) {
				$confWndw = $btn.siblings(".config-window");
				$btn.data("target", $confWndw);
			}
			
			$confWndw.toggleClass("is-open").fadeToggle(200);
			$confWndw.closest("li").toggleClass(
				"has-opened-window",
				$confWndw.hasClass("is-open")
			);
			
			if( !isTrigger && $confWndw.hasClass("is-open") ) {
				// bodyクリックで閉じる
				const $body = vuwer.get("body").$self;
				$body.on("click.closePeriodConfWndw", e => {
					$body.off(".closePeriodConfWndw");
					$btn.trigger("click", [true]);
				});
			}
			
			e.stopPropagation();
		})
		
		.on("click", ".btn-close", e => e.preventDefault())
		
		.on("change", ".inp-radio", (e, isTrigger) => {
			const $thisConfig = $(e.currentTarget).closest(".period-config");
			const { value } = e.currentTarget;
			const $target = $thisConfig.closest(".pd").attr("data-config", value);
			const $fields = $target.children(".field-inp");
			
			// startとendの入れ替え
			if(value === "b") {
				let $start, $end;
				
				if($fields.eq(0).attr("data-period") === "start") {
					// start
					$start = $fields.eq(0).insertAfter(
						$target.children(".period-splitter")
					);
					// end
					$end = $fields.eq(1).insertBefore(
						$target.children(".period-splitter")
					);
					
					// update pair
					const $inpFrom = $end.find(".inp-date.day-from");
					const $inpTo = $start.find(".inp-date.day-to");
					
					$inpFrom.data({ pair: $inpTo });
					$inpTo.data({ pair: $inpFrom });
					
				} else {
					// start
					$start = $fields.eq(1);
					// end
					$end = $fields.eq(0);
				}
				
				$start.find(".inp-date.day-from").val("");
				$end.find(".inp-date.day-to").val("");
				
			} else {
				let $start, $end;
				
				if($fields.eq(0).attr("data-period") === "end") {
					// end
					$end = $fields.eq(0).insertAfter(
						$target.children(".period-splitter")
					);
					
					// start
					$start = $fields.eq(1).insertBefore(
						$target.children(".period-splitter")
					);
					
					// update pair
					const $inpStartTo = $start.find(".inp-date.day-to");
					const $inpEndFrom = $end.find(".inp-date.day-from");
					
					$inpStartTo.data({ pair: $start.find(".inp-date.day-from") });
					$inpEndFrom.data({ pair: $end.find(".inp-date.day-to") });
					
				} else {
					// end
					$end = $fields.eq(1);
					// start
					$start = $fields.eq(0);
				}
				
				if(value === "s") {
					// end
					$end.find(".inp-date").val("");
				} else
				if(value === "e") {
					// start
					$start.find(".inp-date").val("");
				}
			}
			
			e.stopPropagation();
		});
		
		// 初期値の設定
		$config.each((i, elm) => {
			$(elm).find(".inp-radio").eq(0).prop("checked", true).trigger("change", [true]);
		});
	},
	
	/**
	 * filterOffMode: trueの場合用のイベントを登録
	 * @returns this
	 */
	_addEventListenerForFilterOffMode() {
		if(!this.$self) {
			return this;
		}
		
		this.$self
		.on("input.filterOffMode", ".inp-txt", (e, isTrigger) => {
			if(isTrigger) {
				return true;
			}
			
			const elm = e.currentTarget;
			clearTimeout( $.data(elm, "monitorTimer") );
			$.data(elm, "monitorTimer", setTimeout(() => {
				$(elm).trigger("change", [true]);
			}, 200));
		})
		.on("change.filterOffMode", ".pd", (e, isTrigger) => {
			const elm = e.currentTarget;
			clearTimeout( $.data(elm, "changeTimer") );
			$.data(elm, "changeTimer", setTimeout(() => {
				const $pd = $(elm);
				let flg = false;
				
				if( $pd.hasClass("area-checkbox") ) {
					flg = !!$pd.find(".inp-checkbox:checked").length;
				} else
				if( $pd.hasClass("area-period") ) {
					$pd.find(".inp-date").each( (i, inp) => !flg && (flg = !!inp.value) );
				} else {
					$pd.find(".inp").each( (i, inp) => !flg && (flg = !!inp.value) );
				}
				
				$pd.parent().toggleClass("is-active", flg);
				$pd.siblings(".pn").attr( "title", `検索${flg ? "ON" : "OFF"}`);
			}, isTrigger ? 200 : 0));
		});
		
		return this;
	}
};
